import React, { Component } from "react";
import { Layout } from 'antd';
import moment from 'moment';

const { Footer } = Layout;

class FooterApp extends Component {
  render() {
    return (
      <Footer>MAFUME ©{moment().year()}</Footer>
    )
  };
}

export default FooterApp;



// WEBPACK FOOTER //
// ./src/components/footer/footer.js